import React, { useState } from 'react';

export default function Make() {


  return (
    <section id="contact" className="contact-area after-none contact-bg pt-120 pb-120 p-relative fix">
      <div className="container">
        <div className="row justify-content-center align-items-center">
        <div className="col-lg-4 order-2">
                  
                </div>
                <div class="container mt-5">
  <div class="row">
    <div class="col-md-8">

    <div class="col-md-8">
      <h2 className='text-center'>Make An Appointment</h2>
    <div class="row">
    <div class="col-md-6">
  <a href="tel:+918770803211" class="card-link">
    <div class="card cardcolor hover-highlight">
      <div class="card-body text-center">
        <img src='../../assets/img/icon/call.png' class='img-icon' alt='Call Icon'></img> 
        <h3 class="card-title">Let's Talk</h3>
        <p class="card-text">
          <a href="tel:+918770803211" class="card-link">87708-03211</a><br/>
          <a href="tel:+917848003211" class="card-link">78480-03211</a>
        </p>
      </div>
    </div>
  </a>
</div>
<div class="col-md-6">
  <a href="https://wa.me/918770803211" class="card-link" target='_blank'>
    <div class="card cardcolor hover-highlight mr">
      <div class="card-body text-center">
        <img src='../../assets/img/icon/whatsapp.png' class='img-icon' alt='WhatsApp Icon'></img>
        <h3 class="card-title">Let's Chat</h3>
        <p class="card-text">
          87708-03211
        </p>
        78480-03211
      </div>
    </div>
  </a>
</div>
    </div>
    <div class="row mt-3">
    <div class="col-md-12">
  <a href="mailto:write2ismile@gmail.com" class="card-link" target='_blank'>
    <div class="card cardcolor hover-highlight">
      <div class="card-body text-center">
        <img src='../../assets/img/icon/mail.png' class='img-icon' alt='Mail Icon'></img>
        <h3 class="card-title">Email Us</h3>
        <p class="card-text">
          write2ismile@gmail.com
        </p>
      </div>
    </div>
  </a>
</div>
    </div>
  </div>

    </div>
    <div className='col-md-4'>
    <div className="contact-info">
                    <div className="single-cta pb-30 mb-30 wow fadeInUp animated" data-animation="fadeInDown animated" data-delay=".2s" >
                      <div className="f-cta-icon">
                        <br />
                        <br />
                        <br />
                        <i className="fa fa-map-marker" />
                        <br />
                        <br />
                        
                      </div>
                      <br/>
                      <h5>Clinic Address</h5>
                      <ul>
                        <li>Samantarapur</li>
                        <li>Bomikhal</li>
                        <li>Mancheswar</li>
                        <li>Chandrasekharpur</li>
                        <li>Raghunathpur</li>
                      </ul>
                    </div>
                    <div
                      className="single-cta pb-30 mb-30 wow fadeInUp animated" data-animation="fadeInDown animated" data-delay=".2s" >
                      <div className="f-cta-icon">
                        <br />
                        <br />
                        <br />
                        <i className="far fa-clock" />
                        <br />
                        <br />
                        <br />
                      </div>
                      <h5>Working Hours</h5>
                      <p>
                      Monday - Saturday: <b>10:00am-1:00pm </b><br />Monday - Saturday: <b>4:30pm-8:30pm</b> <br />
                      Sunday: <br /> <b>10:00am-1:00pm</b>
                      </p>
                    </div>
                  </div>
    </div>
    
    
  </div>
</div>
        </div>
      </div>
    </section>
  );
}
